import api from '../../../core/api/api';

export const facturacionTecnicosAPI = {
  // Obtener médico por usuario
  getMedicoByUsuario: async (usuario) => {
    const response = await api.get('/Medicos/GetByUserAsync', {
      params: { usuario }
    });
    return response.data;
  },

  // Obtener técnico por usuario
  getTecnicoPorUsuario: async (usuario) => {
    const response = await api.get('/Medicos/ObtenerTecnicoPorUsuario', {
      params: { usuario }
    });
    return response.data;
  },

  // Obtener facturación de técnicos
  getFacturacionTecnicos: async (idTecnico, fechaDesde, fechaHasta) => {
    const response = await api.get('/Billing/GetShiftBillingTechnicians', {
      params: { idMedico: idTecnico, from: fechaDesde, to: fechaHasta, invoice: false }
    });
    return response.data;
  },

  // Obtener facturación completa de técnicos (admin)
  getFacturacionCompletaTecnicos: async (idTecnico, mes, anio) => {
    const params = { mes, anio };
    if (idTecnico) params.idMedico = idTecnico;
    
    const response = await api.get('/Billing/GetCompleteShiftBillingTechnicians', { params });
    return response.data;
  },

  // Obtener detalle de facturación
  getFacturacionDetalleTecnicos: async (idTecnico, fechaDesde, fechaHasta) => {
    const response = await api.get('/Billing/GetCompleteDetailShiftBillingTechnicians', {
      params: { idMedico: idTecnico, from: fechaDesde, to: fechaHasta, invoice: false }
    });
    return response.data;
  },

  // Obtener estado de facturación
  getEstadoFacturacion: async (idTecnico, fechaDesde, fechaHasta) => {
    const response = await api.get('/Billing/GetEstadoFacturacionTecnico', {
      params: { idMedico: idTecnico, fechaDesde, fechaHasta }
    });
    return response.data;
  },

  // Subir factura (técnico)
  uploadFactura: async (formData) => {
    const response = await api.post('/Billing/UploadInvoiceAsync', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Subir comprobante de pago (admin)
  uploadComprobante: async (formData) => {
    const response = await api.post('/Billing/CargarComprobantePagoAsync', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  // Obtener técnicos
  getTecnicos: async () => {
    const response = await api.get('/Medicos/ObtenerTecnicos');
    return response.data;
  },

  // Obtener notificaciones
  getNotificaciones: async (envia, recibe, mes, anio) => {
    const response = await api.get('/Notifications/GetAsync', {
      params: { envia: envia || '', recibe: recibe || '', mes, anio }
    });
    return response.data;
  },

  // Crear notificación
  createNotificacion: async (recibe, mes, anio, mensaje) => {
    const response = await api.post('/Notifications/CreateAsync', {
      recibe,
      mes,
      anio,
      mensaje
    });
    return response.data;
  },

  // Marcar notificación como leída
  updateNotificacion: async (idNotificacion, lectura) => {
    const response = await api.put('/Notifications/UpdateAsync', {
      idNotificacion,
      lectura
    });
    return response.data;
  },

  // Iniciar ciclo de facturación
  iniciarCicloFacturacion: async (idMedico, mes, anio) => {
    const response = await api.post('/Billing/IniciarCicloFacturacionTecnico', {
      idMedico,
      mes,
      anio
    });
    return response.data;
  },

  // Facturar turno individual
  facturarTurno: async (idTurno, estaFacturado) => {
    const response = await api.put('/Billing/FacturarTurno', {
      idTurno,
      estaFacturado
    });
    return response.data;
  },

  // Facturar turnos en lote
  facturarTurnosLote: async (idsTurnos, estaFacturado) => {
    const response = await api.put('/Billing/FacturarTurnosLote', {
      idsTurnos,
      estaFacturado
    });
    return response.data;
  },

  // Cambiar auditoria (estado) de práctica en facturación
  cambiarAuditoria: async (idTurno, auditoria, idMedico) => {
    const response = await api.put('/Billing/CambiarAuditoriaFacturacionTecnico', {
      idTurno,
      auditoria,
      idMedico
    });
    return response.data;
  },

  // Eliminar factura
  eliminarFactura: async (idEstadoFacturacion) => {
    const response = await api.delete('/Billing/EliminarFactura', {
      params: { idEstadoFacturacion }
    });
    return response.data;
  },

  // Eliminar comprobante
  eliminarComprobante: async (idEstadoFacturacion) => {
    const response = await api.delete('/Billing/EliminarComprobante', {
      params: { idEstadoFacturacion }
    });
    return response.data;
  }
};
